// My web app's Firebase configuration
const firebaseConfig = {
        apiKey: "AIzaSyAoeUM0Ze-McnETKHpDgiQO18kr3TdRqDE",
        authDomain: "medinova-center.firebaseapp.com",
        projectId: "medinova-center",
        storageBucket: "medinova-center.appspot.com",
        messagingSenderId: "989033582516",
        appId: "1:989033582516:web:fb8021c698ca7dfa31ace1"
};

export default firebaseConfig;